module.exports = __webpack_public_path__ + "img/scarlets-logo.8229a1b9.svg";